import { render } from "./CoursePreparationStatus.vue?vue&type=template&id=1054c110"
import script from "./CoursePreparationStatus.vue?vue&type=script&lang=js"
export * from "./CoursePreparationStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__